import React from 'react';

export default class  Page5 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <p><span className="subtiltereg">Use ‘I’ statements</span><br/>
                                                Speak from your own perspective rather than passing judgement on
                                                someone else.<br/>
                                                <span className="brown brownbold">Example:</span><span
                                                className="subtiltereg"> ‘I’d like for this meeting to move at a quicker pace.’</span> instead
                                                of<span className="subtiltereg">  ‘You always make meetings go really slowly.’</span> Using
                                                your own perspective makes it more likely that it will be taken
                                                as an observation rather than a criticism, and will be more
                                                likely to be met positively.</p>
                                            <p><span
                                                className="subtiltereg">Use facts, not judgements</span><br/>
                                                <span className="brown brownbold">Example:</span><span
                                                className="subtiltereg"> ‘Your punctuation needs work and your formatting is inconsistent’</span> instead
                                                of <span className="subtiltereg">‘This is sloppy work’</span>.
                                                This makes criticisms or comments objective and fair rather than
                                                seeming like you may be impulsive or biased.</p>
                                            <p><span
                                                className="subtiltereg"> Make clear, direct, requests</span><br/>
                                                Don’t invite the person to say no.<br/>
                                                <span className="brown brownbold">Example:</span> <span
                                                className="subtiltereg"> ‘Will you please…?’</span> instead
                                                of <span
                                                className="subtiltereg"> ‘Would you mind …?’</span> or <span
                                                className="subtiltereg">‘Why don’t you …?’</span></p>
                                            <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span
                                                    className="heading">TECHNIQUES FOR DIFFICULT SITUATIONS</span>
                                            </div>
                                            <p>Now that you have identified some specific situations where you
                                                could be more assertive, it’s time to look at some techniques<a
                                                    className="superscripttext"
                                                    href="further_info.php?course=300"><sup>3</sup></a> which
                                                might aid you.</p>
                                            <div className="border_subtitle">Broken record</div>
                                            <p>Keep repeating your point, using a moderate and pleasant voice.
                                                Don’t get drawn into arguing or explaining yourself. This will
                                                prevent you being manipulated, baited, or getting sidetracked by
                                                irrelevant information.</p>

                                            <p><span className="brown brownbold">Example:</span> You’ve been
                                                handed a report which has been hand-written by a colleague, but
                                                the writing is illegible, so you have asked them to type it up
                                                for you. However, they become irate and repeatedly say they are
                                                too busy, even though you need the review in the next hour.
                                                Using the ‘broken record’ technique, say:<span
                                                    className="subtiltereg"> ‘This writing is illegible, I need it to be typed up please.’</span> Then,
                                                no matter what the colleague says, keep repeating that phrase.
                                                Trust us, it works!</p>
                                            <div className="border_subtitle">Fogging</div>
                                            <p>This is a way to deflect negative, manipulative criticism.
                                                Instead of offering denials or counter-arguments you only agree
                                                with the facts in an argument. This allows you to keep your own
                                                discipline as well as neutralising the argument. Fogging is
                                                great for avoiding fights and deflecting criticism, so use it
                                                when you notice yourself or someone else getting dragged into a
                                                potentially hostile situation.</p>
                                            <p><span className="brown brownbold">Example:</span></p>

                                            <p className="subtiltereg">Colleague: ‘There are some basic mistakes
                                                in this spreadsheet you made, you musn’t be very good at
                                                maths.’</p>
                                            <p className="subtiltereg">You: ‘Oh yes, I see, there are some
                                                errors, I forgot to move that cell over.’</p>
                                            <p className="subtiltereg">Colleague: ‘It’s a pretty stupid error to
                                                make. ’</p>
                                            <p className="subtiltereg">You: ‘Yes, I guess it is quite a simple
                                                error, I’ve made a note of it now, and that should mean it won’t
                                                crop up again.’</p>
                                            <p>Agree with as many facts as you like, but don’t allow the
                                                negative criticism about your maths skills or otherwise to be
                                                bait for starting an argument.</p>

                                            <div className="left-btn"><div
                                                onClick={this.props.handleChangePage('Page4')}
                                                className="button-next-previous-done">&lt;&lt; Previous </div></div>
                                            <div className="right-btn"><div
                                                onClick={this.props.handleChangePage('Page6')}
                                                className="button-next-previous-done">Next &gt;&gt;</div></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                    </div>
                </div>
            </div>
        </div>;
    }
}